document.addEventListener('DOMContentLoaded', function () {
    const bundleContainer = document.querySelector('.sb-bundle-container');
    if (!bundleContainer) return;

    const productId = bundleContainer.dataset.productId;
    const hasSwatches = bundleContainer.dataset.hasSwatches === 'true';
    const packRadios = bundleContainer.querySelectorAll('input[name="sb_pack_selection"]');
    const errorRegion = bundleContainer.querySelector('.sb-error-message');

    // Find nearest product form (from standard Shopify themes)
    const productForm = bundleContainer.closest('form[action*="/cart/add"]') ||
        document.querySelector(`form[action*="/cart/add"][id^="product-form-"]`) ||
        document.querySelector('form[action*="/cart/add"]');

    if (!productForm) return;

    const originalSubmitBtn = productForm.querySelector('[type="submit"], [name="add"]');

    // State to hold selected variant IDs for each Pack's Item 2 and Item 3 natively isolated
    // e.g selections[3][2] = ... and selections[3][3] = ...
    const selections = {
        2: { 2: null },
        3: { 2: null, 3: null }
    };

    let isAdding = false;
    const DEBUG = true;

    function log(...args) {
        if (DEBUG) console.log('[Bundle Debug]', ...args);
    }

    function getSelectedPack() {
        const checked = bundleContainer.querySelector('input[name="sb_pack_selection"]:checked');
        const packValue = checked ? parseInt(checked.value, 10) : 1;
        log('getSelectedPack ->', packValue);
        return packValue;
    }

    function getMainVariantId() {
        // Look for standard Shopify form input or select
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) return variantInput.value;

        const variantSelect = productForm.querySelector('select[name="id"]');
        if (variantSelect && variantSelect.value) return variantSelect.value;

        // If neither exists, check URL for variant parameter as fallback
        const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');
        if (urlVariantId) return urlVariantId;

        // If all else fails, default to first variant from SSR swatches array natively
        const firstElement = bundleContainer.querySelector('.sb-swatch');
        if (firstElement) return firstElement.dataset.id;

        return null;
    }

    function initSwatches() {
        if (!hasSwatches) return;

        const mainVariantId = getMainVariantId();
        log('initSwatches -> mainVariantId found:', mainVariantId);

        let defaultLabel = '';
        const firstSwatch = bundleContainer.querySelector('.sb-swatch');
        if (firstSwatch) defaultLabel = firstSwatch.dataset.label;
        
        if (mainVariantId) {
            const matchBtn = bundleContainer.querySelector(`.sb-swatch[data-id="${mainVariantId}"]`);
            if (matchBtn) defaultLabel = matchBtn.dataset.label;
        }

        [2, 3].forEach(packNum => {
            const packContainer = bundleContainer.querySelector(`.sb-pack-card[data-pack="${packNum}"]`);
            if (!packContainer) return;

            const rows = packContainer.querySelectorAll('.sb-pack-item-row');

            rows.forEach(row => {
                const itemNum = parseInt(row.dataset.item, 10);
                const swatchesContainer = row.querySelector('.sb-pack-item-swatches');
                const labelSpan = row.querySelector('.sb-selected-label');
                
                const swatches = swatchesContainer.querySelectorAll('.sb-swatch');
                if (swatches.length === 0) return;

                let initialSelection = null;

                swatches.forEach(swatch => {
                    const isDisabled = swatch.classList.contains('is-disabled');
                    if (!isDisabled) {
                        if (!initialSelection) {
                            initialSelection = swatch;
                        } else if (swatch.dataset.label === defaultLabel) {
                            initialSelection = swatch;
                        }
                    }

                    swatch.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (isDisabled) return;
                        selectSwatch(packNum, itemNum, swatch.dataset.id, swatch.dataset.label, swatchesContainer, labelSpan);
                    });
                });

                if (initialSelection) {
                    selectSwatch(packNum, itemNum, initialSelection.dataset.id, initialSelection.dataset.label, swatchesContainer, labelSpan);
                }
            });
        });
    }

    function selectSwatch(packNum, itemNum, variantId, label, container, labelSpan) {
        if (labelSpan) labelSpan.textContent = label;
        selections[packNum][itemNum] = variantId;

        const allSwatches = container.querySelectorAll('.sb-swatch');
        allSwatches.forEach(s => s.classList.remove('is-selected'));

        const selectedSwatch = container.querySelector(`.sb-swatch[data-id="${variantId}"]`);
        if (selectedSwatch) selectedSwatch.classList.add('is-selected');
    }

    function init() {
        initSwatches();

        // Listen to pack changes
        packRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                errorRegion.textContent = '';
            });
        });

        // Use capture phase (true) to block event before native listeners run
        productForm.addEventListener('submit', handleFormSubmit, true);
        if (originalSubmitBtn) {
            originalSubmitBtn.addEventListener('click', handleFormSubmit, true);
        }
    }

    function showError(msg) {
        errorRegion.textContent = msg;
        errorRegion.style.display = 'block';
    }

    let handleCount = 0;
    let lastEventTime = 0;

    function handleFormSubmit(e) {
        const now = Date.now();
        if (now - lastEventTime > 1000) handleCount = 0;
        lastEventTime = now;
        handleCount++;

        const pack = getSelectedPack();

        // Let native submit proceed if pack is 1
        if (pack === 1) {
            log('handleFormSubmit -> Pack 1 selected. Letting native form submit proceed.');
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        log(`handleFormSubmit -> Event prevented! Type: ${e.type}, Pack: ${pack}.`);

        if (handleCount > 1) {
            console.warn(`[Bundle Debug] WARNING: handleFormSubmit fired MULTIPLE times per click! (Count: ${handleCount})`);
        }

        if (isAdding) {
            log('handleFormSubmit -> Blocked duplicate submission while isAdding=true');
            return;
        }

        const mainVariantId = getMainVariantId();
        log('handleFormSubmit -> mainVariantId found:', mainVariantId);

        if (!mainVariantId) {
            showError("Please select a valid product variant first.");
            return;
        }

        errorRegion.textContent = '';
        isAdding = true;

        let itemsToAdd = [];

        itemsToAdd.push({
            id: parseInt(mainVariantId, 10),
            quantity: 1
        });

        if (pack >= 2) {
            const v2 = hasSwatches ? selections[pack][2] : mainVariantId;
            log(`handleFormSubmit -> pack ${pack} requires v2:`, v2);
            if (!v2) {
                showError("Please select a variant for Item 2.");
                isAdding = false;
                return;
            }
            itemsToAdd.push({ id: parseInt(v2, 10), quantity: 1 });
        }

        if (pack === 3) {
            const v3 = hasSwatches ? selections[pack][3] : mainVariantId;
            log(`handleFormSubmit -> pack ${pack} requires v3:`, v3);
            if (!v3) {
                showError("Please select a variant for Item 3.");
                isAdding = false;
                return;
            }
            itemsToAdd.push({ id: parseInt(v3, 10), quantity: 1 });
        }

        if (pack === 1 && itemsToAdd.length !== 1) throw new Error("Invalid bundle payload for Single");
        if (pack === 2 && itemsToAdd.length !== 2) throw new Error("Invalid bundle payload for Double");
        if (pack === 3 && itemsToAdd.length !== 3) throw new Error("Invalid bundle payload for Triple");

        const finalItemsArray = itemsToAdd;
        log('handleFormSubmit -> finalItemsArray Payload:', finalItemsArray);
        log(`[Debug Proof] Pack: ${pack} | Prevented: ${e.defaultPrevented} | Payload length: ${finalItemsArray.length} | IDs:`, finalItemsArray.map(i => i.id));

        if (originalSubmitBtn) {
            originalSubmitBtn.disabled = true;
            const originalText = originalSubmitBtn.innerHTML;
            originalSubmitBtn.innerHTML = 'Adding...';

            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/javascript'
                },
                body: JSON.stringify({ items: finalItemsArray })
            };

            // Ensure base URL isn't hardcoded and works in subdirectories if applicable.
            let rootUrl = window.Shopify ? window.Shopify.routes.root : '/';
            if (rootUrl === '') {
                rootUrl = '/';
            }

            fetch(rootUrl + 'cart/add.js', config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status && response.message) {
                        throw new Error(response.description || response.message);
                    }

                    // Fire cart:item-added for theme-level listeners
                    dispatchCustomEvent('cart:item-added', {
                        product: response.hasOwnProperty('items') ? response.items[0] : response
                    });

                    // Fire Meta Pixel AddToCart event directly via fbq
                    // Shopify's native form flow calls fbq automatically, but since we
                    // bypass it with our own fetch for pack 2/3, we must call fbq ourselves
                    if (typeof window.fbq === 'function') {
                        const items = response.hasOwnProperty('items') ? response.items : [response];
                        const totalValue = items.reduce(function(sum, item) {
                            return sum + (item.final_line_price / 100);
                        }, 0).toFixed(2);
                        try {
                            window.fbq('track', 'AddToCart', {
                                content_ids: items.map(function(item) { return String(item.variant_id); }),
                                content_type: 'product',
                                value: parseFloat(totalValue),
                                currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
                                contents: items.map(function(item) {
                                    return {
                                        id: String(item.variant_id),
                                        quantity: item.quantity,
                                        item_price: parseFloat((item.final_price / 100).toFixed(2))
                                    };
                                })
                            });
                            log('fbq AddToCart tracked for bundle pack', pack, '| value:', totalValue);
                        } catch (fbqError) {
                            console.warn('[Bundle] fbq AddToCart call failed:', fbqError);
                        }
                    }

                    dispatchCustomEvent('cart:refresh');

                    const cartDrawer = document.getElementById('Cart-Drawer');
                    if (cartDrawer) {
                        document.body.classList.add('open-cc');
                        document.body.classList.add('open-cart');
                        cartDrawer.classList.add('active');
                        if (cartDrawer.querySelector('.product-recommendations--full')) {
                            cartDrawer.querySelector('.product-recommendations--full').classList.add('active');
                        }
                    } else if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
                        window.CartDrawer.open();
                    } else if (window.theme && typeof window.theme.cart === 'object' && typeof window.theme.cart.open === 'function') {
                        window.theme.cart.open();
                    } else {
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail: {
                                product: response
                            }
                        }));
                    }
                })
                .catch((error) => {
                    console.error('Error adding bundle to cart', error);
                    showError(error.message || "There was an error adding the bundle to the cart.");
                })
                .finally(() => {
                    originalSubmitBtn.disabled = false;
                    originalSubmitBtn.innerHTML = originalText;
                    isAdding = false;
                });
        }
    }

    init();
});
